import { Button } from 'components/ui/button';

interface HoraCertaResultStepProps {
  errorMessage: string | null;
  importedCount: number | null;
  updatedCount: number;
  ignoredCount: number;
  cancelledCount: number;
  onRetry: () => void;
  onReset: () => void;
}

export const HoraCertaResultStep = ({
  errorMessage,
  importedCount,
  updatedCount,
  ignoredCount,
  cancelledCount,
  onRetry,
  onReset,
}: HoraCertaResultStepProps) => (
  <div className="mt-6 max-w-2xl mx-auto bg-white rounded-xl border border-slate-200 shadow-sm p-12 text-center">
    <div
      className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 ${
        errorMessage
          ? 'bg-red-50 border-4 border-red-100'
          : 'bg-emerald-50 border-4 border-emerald-100'
      }`}
    >
      <span className="text-3xl">{errorMessage ? '✕' : '✓'}</span>
    </div>
    <h2 className="font-GilroyBold text-2xl text-slate-900 mb-2">
      {errorMessage
        ? 'Erro ao Importar Planilha'
        : (importedCount ?? 0) > 0
        ? 'Planilha Importada com Sucesso!'
        : 'Nenhum registro enviado para a quarentena'}
    </h2>
    <p className="text-sm text-slate-500 mb-8">
      {errorMessage
        ? errorMessage
        : `Importação concluída.${
            (importedCount ?? 0) - updatedCount > 0
              ? ` ${(importedCount ?? 0) - updatedCount} novo(s) registro(s) enviado(s) para a quarentena.`
              : ''
          }${
            updatedCount > 0
              ? ` ${updatedCount} registro(s) atualizado(s).`
              : ''
          }${
            cancelledCount > 0
              ? ` ${cancelledCount} agendamento(s) cancelado(s) e horário liberado.`
              : ''
          }${
            ignoredCount > 0
              ? ` ${ignoredCount} ignorado(s) por data já passada.`
              : ''
          }${(importedCount ?? 0) - updatedCount > 0 ? ' Revise e aprove na tela de quarentena.' : ''}`}
    </p>
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      {!errorMessage && (importedCount ?? 0) - updatedCount > 0 && (
        <Button
          asChild
          className="bg-[#EE7C2C] hover:bg-[#d4691f] text-white"
        >
          <a href="/importacao/quarentena">Ir para quarentena</a>
        </Button>
      )}
      <Button
        type="button"
        variant="outline"
        onClick={() => (errorMessage ? onRetry() : onReset())}
      >
        {errorMessage ? 'Tentar Novamente' : 'Importar Nova Planilha'}
      </Button>
    </div>
  </div>
);
